import { Component, Input } from "@angular/core";
import { DetailsItemComponent } from "src/app/core/elements/details-item.component";
import { DetailsListComponent } from "src/app/core/elements/details-list.component";
import { DayPipe } from "src/app/core/pipes/day.pipe";
import { HelpAssistTicketAppointmentDraftUpdate } from "src/app/partner/help-assist/models/ticket-appointment-draft/help-assist-ticket-appointment-draft-update.model";
import { HelpAssistTicketAppointmentDraft } from "src/app/partner/help-assist/models/ticket-appointment-draft/help-assist-ticket-appointment-draft.model";
import { HelpAssistTicketAppointmentOrderUpdate } from "src/app/partner/help-assist/models/ticket-order/help-assist-ticket-appointment-order-update.model";
import { HelpAssistTicketAppointmentOrder } from "src/app/partner/help-assist/models/ticket-order/help-assist-ticket-appointment-order.model";

@Component({
  selector: "mr-ticket-po-list[title]",
  templateUrl: "./ticket-po-list.component.html",
  styleUrls: ["./ticket-po-list.component.scss"],
  imports: [DetailsListComponent, DetailsItemComponent, DayPipe],
})
export class TicketPoListComponent {
  @Input() public title?: string;
  @Input() public appointment!:
    HelpAssistTicketAppointmentDraft | HelpAssistTicketAppointmentDraftUpdate;

  public get orders(): ReadonlyArray<
    HelpAssistTicketAppointmentOrder | HelpAssistTicketAppointmentOrderUpdate
  > | null {
    return this.appointment.orders;
  }
}
